import Vue from "vue";

Vue.mixin({
  methods: {
    can(permission) {
      if (permission == 'no-permission') return true;

      let user = this.$auth.user();

      return user
        && user.permissions_list
        && user.permissions_list.includes(permission);
    }
  }
});
